import script from "./ProjectFilterBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectFilterBar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__